import type { Metadata } from 'next';

import { DEFAULT_META } from '@/constants';

export const CAMPAIGN_PAGE_SIZE = 20;

export const GIFT_TRIAL_OPEN_GRAPH = {
  ...DEFAULT_META.openGraph,
  title: '웰로 답례품 체험단',
  description: '신선한 지역 답례품, 무료로 체험해요!',
  images: 'https://cdn.welfarehello.com/static/gift-trial/og.png',
} satisfies Metadata['openGraph'];
